import React from 'react';
import { apiGetPhoto, apiIsLoggedIn } from '../../../api/api';

class ReunionPhoto extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imageUrl: null,
        }
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            return;
        }

        const getPhotoResponse = await apiGetPhoto(this.props.photoUri);
        
        if (!getPhotoResponse.ok) {
            return;
        }

        const photoBlob = await getPhotoResponse.blob();
        const imageObjectURL = URL.createObjectURL(photoBlob);
        
        this.setState({
            ...this.state,
            imageUrl: imageObjectURL,
        });
    }

    render() {
        return (
            <div>
                {this.state.imageUrl ? 
                    <a href={this.state.imageUrl} target='_blank'>
                        <img src={this.state.imageUrl} style={this.props.style ? this.props.style : {width: 250, height: '100%'}} />
                    </a>
                : <p>Loading...</p>}
            </div>
        )
    }
}

export default ReunionPhoto;
